export default __webpack_public_path__ + "static/media/ethereum.524959f5.svg";